import React, { useEffect, useState } from 'react';
import SectionOne from './SectionOne';
import SectionFour from './SectionFour';
import SectionThree from './SectionThree';
import SectionTwo from './SectionTwo';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
const apiKey = process.env.REACT_APP_SECURE_KEY;

const Home = () => {
  const [data, setData] = useState();
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#tutorials") {
      const section = document.getElementById("tutorials");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    axios
      .get(`${apiKey}/course/get_topic`)
      .then(function (response) {
        setData(response.data.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);
  return (
    <>
      <SectionOne />
      <br />
      <Link to='/Course'><img src="./images/course_banner.png" alt="Course" className='course_img' /></Link>
      <Link to='/Course'><img src="./images/course_banner_mobile_view.png" alt="Course" className='course_img_banner' /></Link>
      <SectionTwo data={data} id="tutorials" />
      <SectionThree />
      <SectionFour />
    </>
  );
};

export default Home;
